import {
  type MutationOptions,
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import {
  getClassPasswordApiQueryKey,
  type ClassPassword,
} from '../use-get-class-password-api/use-get-class-password-api';

export async function updateClassPasswordApi(
  classPassword: ClassPassword
): Promise<ClassPassword> {
  return fetcher<ClassPassword>('/class-passwords', {
    method: 'PUT',
    service: '/roster',
    version: '/v1',
    body: JSON.stringify(classPassword),
  });
}

export function useUpdateClassPasswordApi(
  customMutationOptions?: Omit<
    MutationOptions<
      ClassPassword,
      ApiError<{ code: string; message: string }>,
      ClassPassword
    >,
    'mutationFn'
  >
): UseMutationResult<
  ClassPassword,
  ApiError<{ code: string; message: string }>,
  ClassPassword
> {
  const queryClient = useQueryClient();
  const { onSuccess, ...opts } = customMutationOptions ?? {};

  return useMutation({
    mutationFn: (classPassword: ClassPassword) =>
      updateClassPasswordApi(classPassword),
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(getClassPasswordApiQueryKey(), data);

      onSuccess?.(data, variables, context);
    },
    ...opts,
  });
}
